module.exports = __webpack_public_path__ + "static/media/jacktop-vip-vault.1e44f52a.webp";